import React, { useState, useEffect } from "react";

const FromWebsites = ({ setUrl, url }) => {
    const [inputUrl, setInputUrl] = useState(url || "");
    const [error, setError] = useState(null);

    useEffect(() => {
        setInputUrl(url);
    }, [url]);

    const validateUrl = (url) => {
        const urlPattern = new RegExp(
            "^(https?:\\/\\/)" + // Protocole obligatoire (http:// ou https://)
                "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|" + // Nom de domaine
                "((\\d{1,3}\\.){3}\\d{1,3}))" + // Adresse IP (optionnelle)
                "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // Port et chemin (optionnels)
                "(\\?[;&a-z\\d%_.~+=-]*)?" + // Chaîne de requête (optionnelle)
                "(\\#[-a-z\\d_]*)?$", // Fragment (optionnel)
            "i"
        );
        return urlPattern.test(url);
    };

    const handleUrlChange = (e) => {
        const newUrl = e.target.value;
        setInputUrl(newUrl);

        if (validateUrl(newUrl)) {
            setUrl(newUrl);
            setError(null);
        } else {
            setError("The URL must be valid and start with http:// or https://");
        }
    };

    return (
        <div className="input-url">
            <input
                type="text"
                placeholder="Enter a website's page URL"
                value={inputUrl}
                onChange={handleUrlChange}
                className="input full-width input-space"
                style={{ borderColor: error ? "var(--pink)" : "" }}
            />
            {error && <p className="error-text">{error}</p>}
        </div>
    );
};

export default FromWebsites;
